module.exports = __webpack_public_path__ + "img/camera_board-wcamera.d679bac5.jpg";